import { Link } from 'react-router-dom';
import { sportsCategories } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; iconBg: string; border: string }> = {
  primary: {
    bg: 'hover:bg-primary-500/5',
    text: 'text-primary-600',
    iconBg: 'bg-primary-100',
    border: 'border-primary-200/70',
  },
  accent: {
    bg: 'hover:bg-accent-500/5',
    text: 'text-accent-600',
    iconBg: 'bg-accent-100',
    border: 'border-accent-200/70',
  },
  secondary: {
    bg: 'hover:bg-secondary-500/5',
    text: 'text-secondary-600',
    iconBg: 'bg-secondary-100',
    border: 'border-secondary-200/70',
  },
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热门体育分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            覆盖全球主流体育项目，选择您感兴趣的体育分类，开启精彩体育之旅
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {sportsCategories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`group p-4 md:p-5 rounded-xl border ${colors.border} bg-background-50 ${colors.bg} transition-all duration-300 cursor-pointer flex flex-col items-center text-center`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 ${colors.iconBg} rounded-xl flex items-center justify-center mb-3 md:mb-4 transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${cat.icon} ${colors.text} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}